{
  "dismiss": "閉じる"
}